import { useState, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import roleService from '../services/role.service'

export const useRoles = () => {
    const [searchText, setSearchText] = useState('')

    // Fetch roles from API
    const { data: roles = [], isLoading, error, refetch } = useQuery({
        queryKey: ['roles'],
        queryFn: roleService.getRoles,
    })

    // Filter roles based on search text
    const filteredRoles = useMemo(() => {
        if (!searchText || !Array.isArray(roles)) return Array.isArray(roles) ? roles : []
        
        return roles.filter(role => 
            role.name?.toLowerCase().includes(searchText.toLowerCase()) ||
            role.display_name?.toLowerCase().includes(searchText.toLowerCase()) ||
            role.description?.toLowerCase().includes(searchText.toLowerCase())
        )
    }, [roles, searchText])

    return {
        roles: filteredRoles,
        searchText,
        setSearchText,
        totalRoles: roles.length,
        isLoading,
        error,
        refetch,
    }
}
